module.exports = __webpack_public_path__ + "img/52002741_L.a651fcbc.png";